import React from 'react';

import { Box } from '@mui/material';

import { User } from '../../../graphql/API';
import { markHighlight } from '../../../redux/features/invite/inviteSlice';
import { useAppDispatch } from '../../../redux/hooks';
import CreateInviteProvider from '../../Dialogs/CreateInvite/context/CreateInvite.provider';
import { InviteStepsContainer } from './CollabInvite';

export const CollabInviteWithoutReducer: React.FC<{ users: User[]; onBack?: () => void }> = ({
  users,
  onBack,
}) => {
  const appDispatch = useAppDispatch();

  return (
    <Box>
      <CreateInviteProvider
        users={users}
        onSuccess={() => {
          appDispatch(markHighlight(true));
        }}
      >
        <InviteStepsContainer onBack={onBack} />
      </CreateInviteProvider>
    </Box>
  );
};
